/* eslint-disable camelcase */
import { IReview, IReviewItem } from "~/review/interfaces";
import { store } from "~/state/store";
import { IPutReview } from "./review";

export function getPutReviewOutput(data: IPutReview): {
	review: IReview;
	myReview: IReviewItem;
} {
	const id = Math.random() * 10000000000 >>> 0;
	const { user } = store.getState().user;
	const review_rating_stars = Math.max(Math.random() * 5 >>> 0, 1);

	return {
		review: {
			total: Math.random() * 1000 >>> 0,
			caption: "",
			review_weight: Math.random(),
			review_rating: Math.random() * 100 >>> 0,
			review_rating_stars,
			review_rating_caption: "",
			use_rating: true,
			use_total: true,
			type: data.source === "firm" ? "firm" : "generic",
		},
		myReview: {
			id,
			text: data.text,
			rating: data.rating,
			enableEdit: true,
			lang: "cs",
			likes: {
				count: 0,
				id: `review.firm.${id}`,
				rawCount: 0,
				voted: false,
			},
			gallery: data.mediaIds.map(item => ({
				id: item,
				size: [2880, 3840],
				status: "approved",
				urls: {
					default: "https://d34-a.sdn.test.dszn.cz/d_34/c_img_QJ_Do/0ZoG76.jpeg?fl=res,{width},{height},1",
				},
			})),
			structured_rating: Object.keys(data.structuredRating).map(key => ({
				key: data.structuredRating[key].key,
				label: "Popis sluzby",
				name: data.structuredRating[key].key,
				rating: data.structuredRating[key].value,
			})),
			rejectReason: "",
			review_source: "mapy-web",
			state: "approved",
			type: data.source === "firm" ? "firm" : "generic",
			updated: new Date().toString(),
			user: {
				bank_id: user.bankId,
				image_url: user.avatar,
				name: user.username || "ReviewerName",
				public_id: user.userPublicId,
				review_count: Math.random() * 1000 >>> 0,
				verified: null,
			},
			weight: Math.random(),
		},
	};
}

export function getActiveRequests() {
	/* eslint-disable */
	return {
		"total": 5,
		"total_new": 0,
		"events": [
			{
				"id": 517049,
				"action": "photo_uploaded",
				"state": "sent",
				"source": "firm",
				"backend": "firmy",
				"time": 1690272338,
				"created": 1690272338,
				"user_id": "44362571",
				"user_source": "rus",
				"data": {
					"poi": {
						"source": "firm",
						"id": 226400,
						"poiagg": {
							"enabled": true,
							"extend": {
								"address": {
									"city": "Praha",
									"district": "Praha",
									"street": "Plzeňská",
									"zip": "15000"
								},
								"contact": {
									"email": {
										"label": "E-mail",
										"value": [
											"cs88@robinoil.cz"
										]
									},
									"phone": {
										"label": "Phone",
										"value": [
											{
												"countrycode": "+420",
												"number": "257213891",
												"type": "phone"
											}
										]
									},
									"url": "http://www.robinoil.cz#utm_source=mapy.cz&utm_medium=ppd&utm_campaign=firmy.cz-226400"
								},
								"fuel": {
									"label": "Fuel prices on 06/24/2023",
									"value": [
										{
											"currency": "CZK",
											"date": 1687557600,
											"id": 2,
											"name": "Petrol",
											"price": "37,29 Kč",
											"priceValue": "37.29"
										},
										{
											"currency": "CZK",
											"date": 1687557600,
											"id": 1,
											"name": "Diesel",
											"price": "31,80 Kč",
											"priceValue": "31.80"
										}
									]
								},
								"opening": {
									"actual": "today nonstop",
									"actualSeason": 0,
									"actualState": "open",
									"actualStateCaption": "Open",
									"label": "Opening hours",
									"lang": "en",
									"seasons": [
										{
											"active": 2,
											"days": {
												"1": {
													"date": "2023-07-31",
													"interval": [],
													"specificationId": "nonstop",
													"specificationText": "Nonstop"
												},
												"2": {
													"date": "2023-07-25",
													"interval": [],
													"specificationId": "nonstop",
													"specificationText": "Nonstop"
												},
												"3": {
													"date": "2023-07-26",
													"interval": [],
													"specificationId": "nonstop",
													"specificationText": "Nonstop"
												},
												"4": {
													"date": "2023-07-27",
													"interval": [],
													"specificationId": "nonstop",
													"specificationText": "Nonstop"
												},
												"5": {
													"date": "2023-07-28",
													"interval": [],
													"specificationId": "nonstop",
													"specificationText": "Nonstop"
												},
												"6": {
													"date": "2023-07-29",
													"interval": [],
													"specificationId": "nonstop",
													"specificationText": "Nonstop"
												},
												"7": {
													"date": "2023-07-30",
													"interval": [],
													"specificationId": "nonstop",
													"specificationText": "Nonstop"
												}
											},
											"end": 1231,
											"label": "01 January – 31 December",
											"start": 101
										}
									],
									"timezone": 7200
								}
							},
							"fulltextPopularity": 0.34052199125289917,
							"fulltextPopularityBrand": 0.3358120024204254,
							"id": 226400,
							"inactive": false,
							"isCenter": false,
							"mark": {
								"lat": 50.0685497222,
								"lon": 14.3528405556
							},
							"media": {
								"mimetype": "image/jpg",
								"urls": {
									"1x1": "//d48-a.sdn.cz/d_48/c_img_H_D/8LcBjiC.jpeg?fl=res,{width},{height},3",
									"default": "//d48-a.sdn.cz/d_48/c_img_H_D/8LcBjiC.jpeg?fl=res,{width},{height},1"
								}
							},
							"multiTitle": [
								"Robin Oil",
								"Plzeňská, Prague, Czechia"
							],
							"popularity": 0.30994001030921936,
							"popularityBrand": 0.3371860086917877,
							"review": {
								"agingDailyMultiplier": 0.9981,
								"averageReviewPercentage": 85.112,
								"caption": "Review",
								"label": "Review",
								"penalized": false,
								"reviewAgingSpeed": "rychle stárnoucí",
								"reviewCount": 4,
								"reviewCountWeighted": 2.567470437335831,
								"reviewLabel": "Great",
								"review_rating": 85,
								"review_rating_caption": "Great",
								"review_rating_stars": 4.3,
								"review_weight": 2.567470437335831,
								"stars": 4.3,
								"total": 4,
								"type": "firm",
								"url": "https://en.firmy.cz/company/226400-robin-oil-praha.html#reviews-more ",
								"useReviews": false,
								"useReviewsThreshold": 4.35,
								"use_rating": false,
								"use_total": true
							},
							"source": "firm",
							"stats": {
								"isPaid": false,
								"query": "",
								"subjectId": 2037678
							},
							"title": "Robin Oil",
							"titleVars": {
								"locationMain1": "Plzeňská, Prague, Czechia",
								"locationMain2": [
									"Plzeňská",
									"Prague, Czechia"
								],
								"specification": "Petrol station",
								"titleSmartMain": "Robin Oil"
							},
							"typeId": 5313,
							"typeName": "Petrol station"
						},
						"poiagg_timestamp": 1690272338779
					}
				},
				"scheduled": 1690272338,
				"firm_id": 226400,
				"canBeRated": true,
				"review_data": {
					"total": 4,
					"caption": "Hodnocení",
					"review_weight": 2.567470437335831,
					"review_rating": 85,
					"review_rating_stars": 4.3,
					"review_rating_caption": "Great",
					"use_rating": false,
					"use_total": true,
					"type": "firm",
					"structured_rating": [],
					"target_stars": 4,
					"reviews": [],
					"review_poi": {
						"source": "firm",
						"id": 226400
					}
				}
			},
			{
				"id": 517047,
				"action": "photo_uploaded",
				"state": "sent",
				"source": "firm",
				"backend": "firmy",
				"time": 1690272323,
				"created": 1690272323,
				"user_id": "44362571",
				"user_source": "rus",
				"data": {
					"poi": {
						"source": "firm",
						"id": 453223,
						"poiagg": {
							"enabled": true,
							"extend": {
								"address": {
									"additional_info": "direction to the centre",
									"city": "Praha",
									"district": "Praha",
									"street": "Plzeňská",
									"zip": "15000"
								},
								"contact": {
									"email": {
										"label": "E-mail",
										"value": [
											"station.praha.plzenskajih@omv.com"
										]
									},
									"phone": {
										"label": "Phone",
										"value": [
											{
												"countrycode": "+420",
												"number": "257223961",
												"type": "phone"
											}
										]
									},
									"url": "https://www.omv.cz/cs-cz#utm_source=mapy.cz&utm_medium=ppd&utm_campaign=firmy.cz-453223"
								},
								"fuel": {
									"label": "Fuel prices on 06/23/2023",
									"value": [
										{
											"currency": "CZK",
											"date": 1687471200,
											"id": 2,
											"name": "Petrol",
											"price": "38,70 Kč",
											"priceValue": "38.70"
										},
										{
											"currency": "CZK",
											"date": 1687557600,
											"id": 1,
											"name": "Diesel",
											"price": "33,90 Kč",
											"priceValue": "33.90"
										}
									]
								},
								"opening": {
									"actual": "today nonstop",
									"actualSeason": 0,
									"actualState": "open",
									"actualStateCaption": "Open",
									"label": "Opening hours",
									"lang": "en",
									"seasons": [
										{
											"active": 2,
											"days": {
												"1": {
													"date": "2023-07-31",
													"interval": [],
													"specificationId": "nonstop",
													"specificationText": "Nonstop"
												},
												"2": {
													"date": "2023-07-25",
													"interval": [],
													"specificationId": "nonstop",
													"specificationText": "Nonstop"
												},
												"3": {
													"date": "2023-07-26",
													"interval": [],
													"specificationId": "nonstop",
													"specificationText": "Nonstop"
												},
												"4": {
													"date": "2023-07-27",
													"interval": [],
													"specificationId": "nonstop",
													"specificationText": "Nonstop"
												},
												"5": {
													"date": "2023-07-28",
													"interval": [],
													"specificationId": "nonstop",
													"specificationText": "Nonstop"
												},
												"6": {
													"date": "2023-07-29",
													"interval": [],
													"specificationId": "nonstop",
													"specificationText": "Nonstop"
												},
												"7": {
													"date": "2023-07-30",
													"interval": [],
													"specificationId": "nonstop",
													"specificationText": "Nonstop"
												}
											},
											"end": 1231,
											"label": "01 January – 31 December",
											"start": 101
										}
									],
									"timezone": 7200
								}
							},
							"fulltextPopularity": 0.2089879959821701,
							"fulltextPopularityBrand": 0.15035399794578552,
							"id": 453223,
							"inactive": false,
							"isCenter": false,
							"mark": {
								"lat": 50.0690491667,
								"lon": 14.3586372222
							},
							"media": {},
							"multiTitle": [
								"OMV",
								"Plzeňská, Prague, Czechia"
							],
							"popularity": 0.21347199380397797,
							"popularityBrand": 0.17137500643730164,
							"review": {
								"agingDailyMultiplier": 0.9981,
								"averageReviewPercentage": 80,
								"caption": "Review",
								"label": "Review",
								"penalized": false,
								"reviewAgingSpeed": "rychle stárnoucí",
								"reviewCount": 1,
								"reviewCountWeighted": 0.2921795446162247,
								"reviewLabel": "Very good",
								"review_rating": 80,
								"review_rating_caption": "Very good",
								"review_rating_stars": 4,
								"review_weight": 0.2921795446162247,
								"stars": 4,
								"total": 1,
								"type": "firm",
								"url": "https://en.firmy.cz/company/453223-omv-praha.html#reviews-more ",
								"useReviews": false,
								"useReviewsThreshold": 4.35,
								"use_rating": false,
								"use_total": true
							},
							"source": "firm",
							"stats": {
								"isPaid": false,
								"query": "",
								"subjectId": 2034882
							},
							"title": "OMV",
							"titleVars": {
								"locationMain1": "Plzeňská, Prague, Czechia",
								"locationMain2": [
									"Plzeňská",
									"Prague, Czechia"
								],
								"specification": "Petrol station",
								"titleSmartMain": "OMV"
							},
							"typeId": 5313,
							"typeName": "Petrol station"
						},
						"poiagg_timestamp": 1690272323577
					}
				},
				"scheduled": 1690272323,
				"firm_id": 453223,
				"canBeRated": true,
				"review_data": {
					"total": 1,
					"caption": "Hodnocení",
					"review_weight": 0.2921795446162247,
					"review_rating": 80,
					"review_rating_stars": 4,
					"review_rating_caption": "Very good",
					"use_rating": false,
					"use_total": true,
					"type": "firm",
					"structured_rating": [],
					"target_stars": 4,
					"reviews": [],
					"review_poi": {
						"source": "firm",
						"id": 453223
					}
				}
			},
			{
				"id": 517045,
				"action": "navigation_point_reached",
				"state": "sent",
				"source": "firm",
				"backend": "mobile",
				"time": 1690272137,
				"created": 1690272152,
				"user_id": "44362571",
				"user_source": "rus",
				"data": {
					"poi": {
						"source": "firm",
						"id": 13369738,
						"poiagg": {
							"enabled": true,
							"extend": {
								"address": {
									"city": "Praha, Smíchov",
									"district": "Praha 5",
									"house_num": "2576/210",
									"street": "Plzeňská",
									"zip": "15000"
								},
								"contact": {
									"email": {
										"label": "E-mail",
										"value": [
											"jana@krutonfilm.cz"
										]
									},
									"url": "https://www.kinokavalirka.cz#utm_source=mapy.cz&utm_medium=ppd&utm_campaign=firmy.cz-13369738"
								}
							},
							"fulltextPopularity": 0.5183230042457581,
							"fulltextPopularityBrand": 0.1908169984817505,
							"id": 13369738,
							"inactive": false,
							"isCenter": false,
							"mark": {
								"lat": 50.0700724676,
								"lon": 14.3679324973
							},
							"media": {},
							"multiTitle": [
								"Kino Kavalírka",
								"Plzeňská 2576/210, Prague 5 - Smíchov, Czechia"
							],
							"popularity": 0.3227519989013672,
							"popularityBrand": 0.25931400060653687,
							"review": {
								"agingDailyMultiplier": 0.9981,
								"averageReviewPercentage": 82.581,
								"caption": "Review",
								"label": "Review",
								"penalized": false,
								"reviewAgingSpeed": "rychle stárnoucí",
								"reviewCount": 6,
								"reviewCountWeighted": 4.1127613165464245,
								"reviewLabel": "Very good",
								"review_rating": 83,
								"review_rating_caption": "Very good",
								"review_rating_stars": 4.1000000000000005,
								"review_weight": 4.1127613165464245,
								"stars": 4.1000000000000005,
								"total": 6,
								"type": "firm",
								"url": "https://en.firmy.cz/company/13369738-kino-kavalirka-praha-smichov.html#reviews-more ",
								"useReviews": false,
								"useReviewsThreshold": 4.35,
								"use_rating": false,
								"use_total": true
							},
							"source": "firm",
							"stats": {
								"isPaid": false,
								"query": "",
								"subjectId": 3945778
							},
							"title": "Kino Kavalírka",
							"titleVars": {
								"locationMain1": "Plzeňská 2576/210, Prague 5 - Smíchov, Czechia",
								"locationMain2": [
									"Plzeňská 2576/210",
									"Prague 5 - Smíchov, Czechia"
								],
								"specification": "Cinema",
								"titleSmartMain": "Kino Kavalírka"
							},
							"typeId": 5214,
							"typeName": "Cinema"
						},
						"poiagg_timestamp": 1690272152618
					},
					"receivedBy": "vectmap"
				},
				"scheduled": 1690272152,
				"firm_id": 13369738,
				"canBeRated": true,
				"review_data": {
					"total": 6,
					"caption": "Hodnocení",
					"review_weight": 4.1127613165464245,
					"review_rating": 82,
					"review_rating_stars": 4.1,
					"review_rating_caption": "Very good",
					"use_rating": false,
					"use_total": true,
					"type": "firm",
					"structured_rating": [],
					"target_stars": 4,
					"reviews": [],
					"review_poi": {
						"source": "firm",
						"id": 13369738
					}
				}
			},
			{
				"id": 517031,
				"action": "photo_uploaded",
				"state": "sent",
				"source": "firm",
				"backend": "firmy",
				"time": 1689752229,
				"created": 1689752229,
				"user_id": "44362571",
				"user_source": "rus",
				"data": {
					"poi": {
						"source": "firm",
						"id": 1983351,
						"poiagg": {
							"enabled": true,
							"extend": {
								"address": {
									"city": "Železný Brod",
									"district": "Jablonec nad Nisou",
									"house_num": "144",
									"street": "Husova",
									"zip": "46822"
								},
								"contact": {
									"email": {
										"label": "E-mail",
										"value": [
											"sefr.zdenka@seznam.cz"
										]
									},
									"phone": {
										"label": "Phone",
										"value": [
											{
												"countrycode": "+420",
												"number": "483391268",
												"type": "phone"
											}
										]
									},
									"url": "https://u-zvonice.eatbu.com/?lang=cs#utm_source=mapy.cz&utm_medium=ppd&utm_campaign=firmy.cz-1983351"
								},
								"opening": {
									"actual": "today to 21",
									"actualSeason": 0,
									"actualState": "open",
									"actualStateCaption": "Open",
									"label": "Opening hours",
									"lang": "en",
									"seasons": [
										{
											"active": 2,
											"days": {
												"1": {
													"date": "2023-07-31",
													"interval": [
														[
															[
																11,
																0
															],
															[
																21,
																0
															]
														]
													],
													"specificationId": "open",
													"specificationText": "Open"
												},
												"2": {
													"date": "2023-07-25",
													"interval": [
														[
															[
																11,
																0
															],
															[
																21,
																0
															]
														]
													],
													"specificationId": "open",
													"specificationText": "Open"
												},
												"3": {
													"date": "2023-07-26",
													"interval": [
														[
															[
																11,
																0
															],
															[
																21,
																0
															]
														]
													],
													"specificationId": "open",
													"specificationText": "Open"
												},
												"4": {
													"date": "2023-07-27",
													"interval": [
														[
															[
																11,
																0
															],
															[
																21,
																0
															]
														]
													],
													"specificationId": "open",
													"specificationText": "Open"
												},
												"5": {
													"date": "2023-07-28",
													"interval": [
														[
															[
																11,
																0
															],
															[
																22,
																0
															]
														]
													],
													"specificationId": "open",
													"specificationText": "Open"
												},
												"6": {
													"date": "2023-07-29",
													"interval": [
														[
															[
																11,
																0
															],
															[
																22,
																0
															]
														]
													],
													"specificationId": "open",
													"specificationText": "Open"
												},
												"7": {
													"date": "2023-07-30",
													"interval": [
														[
															[
																11,
																0
															],
															[
																18,
																0
															]
														]
													],
													"specificationId": "open",
													"specificationText": "Open"
												}
											},
											"end": 1231,
											"label": "01 January – 31 December",
											"start": 101
										}
									],
									"timezone": 7200
								}
							},
							"fulltextPopularity": 0.3801420032978058,
							"fulltextPopularityBrand": 0.3292669951915741,
							"id": 1983351,
							"inactive": false,
							"isCenter": false,
							"mark": {
								"lat": 50.6424092468,
								"lon": 15.2555177603
							},
							"media": {
								"mimetype": "image/jpg",
								"urls": {
									"1x1": "//d48-a.sdn.cz/d_48/c_img_H_D/1DoeQn.jpeg?fl=res,{width},{height},3",
									"default": "//d48-a.sdn.cz/d_48/c_img_H_D/1DoeQn.jpeg?fl=res,{width},{height},1"
								}
							},
							"multiTitle": [
								"Restaurace U Zvonice",
								"Husova 144, Železný Brod, Czechia"
							],
							"popularity": 0.3564459979534149,
							"popularityBrand": 0.3291740119457245,
							"review": {
								"agingDailyMultiplier": 0.9981,
								"averageReviewPercentage": 89.024,
								"caption": "Review",
								"label": "Review",
								"penalized": false,
								"reviewAgingSpeed": "rychle stárnoucí",
								"reviewCount": 28,
								"reviewCountWeighted": 15.89687794031442,
								"reviewLabel": "Great",
								"review_rating": 89,
								"review_rating_caption": "Great",
								"review_rating_stars": 4.5,
								"review_weight": 15.89687794031442,
								"stars": 4.5,
								"total": 28,
								"type": "firm",
								"url": "https://en.firmy.cz/company/1983351-restaurace-u-zvonice-zelezny-brod.html#reviews-more ",
								"useReviews": true,
								"useReviewsThreshold": 4.35,
								"use_rating": true,
								"use_total": true
							},
							"source": "firm",
							"stats": {
								"isPaid": false,
								"query": "",
								"subjectId": 2243883
							},
							"title": "Restaurace U Zvonice",
							"titleVars": {
								"locationMain1": "Husova 144, Železný Brod, Czechia",
								"locationMain2": [
									"Husova 144",
									"Železný Brod, Czechia"
								],
								"specification": "Restaurants",
								"titleSmartMain": "Restaurace U Zvonice"
							},
							"typeId": 5322,
							"typeName": "Restaurants"
						},
						"poiagg_timestamp": 1689752229192
					}
				},
				"scheduled": 1689752229,
				"firm_id": 1983351,
				"canBeRated": true,
				"review_data": {
					"total": 28,
					"caption": "Hodnocení",
					"review_weight": 15.89687794031442,
					"review_rating": 89,
					"review_rating_stars": 4.5,
					"review_rating_caption": "Great",
					"use_rating": true,
					"use_total": true,
					"type": "firm",
					"structured_rating": [
						{
							"key": "jidloapiti",
							"name": "Food and drink",
							"label": "Quality",
							"rating": null
						},
						{
							"key": "obsluha",
							"name": "Service",
							"label": "Your satisfaction with service",
							"rating": null
						},
						{
							"key": "prostredi",
							"name": "Interior",
							"label": "Attractiveness",
							"rating": null
						},
						{
							"key": "cena",
							"name": "Price",
							"label": "Corresponding with offered services",
							"rating": null
						}
					],
					"target_stars": 4,
					"reviews": [],
					"review_poi": {
						"source": "firm",
						"id": 1983351
					}
				}
			},
			{
				"id": 517030,
				"action": "photo_uploaded",
				"state": "sent",
				"source": "firm",
				"backend": "firmy",
				"time": 1689752143,
				"created": 1689752143,
				"user_id": "44362571",
				"user_source": "rus",
				"data": {
					"poi": {
						"source": "firm",
						"id": 12832594,
						"poiagg": {
							"enabled": true,
							"extend": {
								"address": {
									"city": "Růžová",
									"district": "Děčín",
									"house_num": "30",
									"zip": "40502"
								},
								"contact": {
									"email": {
										"label": "E-mail",
										"value": [
											"restauraceruzova@seznam.cz"
										]
									},
									"phone": {
										"label": "Phone",
										"value": [
											{
												"countrycode": "+420",
												"number": "733313748",
												"type": "mobile"
											}
										]
									},
									"url": "http://www.restauraceruzova.cz#utm_source=mapy.cz&utm_medium=ppd&utm_campaign=firmy.cz-12832594"
								},
								"opening": {
									"actual": "today to 22",
									"actualSeason": 0,
									"actualState": "open",
									"actualStateCaption": "Open",
									"label": "Opening hours",
									"lang": "en",
									"seasons": [
										{
											"active": 2,
											"days": {
												"1": {
													"date": "2023-07-31",
													"interval": [
														[
															[
																12,
																0
															],
															[
																22,
																0
															]
														]
													],
													"specificationId": "open",
													"specificationText": "Open"
												},
												"2": {
													"date": "2023-07-25",
													"interval": [
														[
															[
																12,
																0
															],
															[
																22,
																0
															]
														]
													],
													"specificationId": "open",
													"specificationText": "Open"
												},
												"3": {
													"date": "2023-07-26",
													"interval": [
														[
															[
																12,
																0
															],
															[
																22,
																0
															]
														]
													],
													"specificationId": "open",
													"specificationText": "Open"
												},
												"4": {
													"date": "2023-07-27",
													"interval": [
														[
															[
																12,
																0
															],
															[
																22,
																0
															]
														]
													],
													"specificationId": "open",
													"specificationText": "Open"
												},
												"5": {
													"date": "2023-07-28",
													"interval": [
														[
															[
																12,
																0
															],
															[
																24,
																0
															]
														]
													],
													"specificationId": "open",
													"specificationText": "Open"
												},
												"6": {
													"date": "2023-07-29",
													"interval": [
														[
															[
																12,
																0
															],
															[
																24,
																0
															]
														]
													],
													"specificationId": "open",
													"specificationText": "Open"
												},
												"7": {
													"date": "2023-07-30",
													"interval": [
														[
															[
																12,
																0
															],
															[
																20,
																0
															]
														]
													],
													"specificationId": "open",
													"specificationText": "Open"
												}
											},
											"end": 1231,
											"label": "01 January – 31 December",
											"start": 101
										}
									],
									"timezone": 7200
								}
							},
							"fulltextPopularity": 0.27025100588798523,
							"fulltextPopularityBrand": 0.2505899965763092,
							"id": 12832594,
							"inactive": false,
							"isCenter": false,
							"mark": {
								"lat": 50.8439360364,
								"lon": 14.2921040477
							},
							"media": {},
							"multiTitle": [
								"Restaurace U kostela",
								"Růžová 30, Růžová, Czechia"
							],
							"popularity": 0.33026498556137085,
							"popularityBrand": 0.2934649884700775,
							"review": {
								"agingDailyMultiplier": 0.9981,
								"averageReviewPercentage": 84.172,
								"caption": "Review",
								"label": "Review",
								"penalized": false,
								"reviewAgingSpeed": "rychle stárnoucí",
								"reviewCount": 31,
								"reviewCountWeighted": 13.781133303739507,
								"reviewLabel": "Very good",
								"review_rating": 84,
								"review_rating_caption": "Very good",
								"review_rating_stars": 4.2,
								"review_weight": 13.781133303739507,
								"stars": 4.2,
								"total": 31,
								"type": "firm",
								"url": "https://en.firmy.cz/company/12832594-restaurace-u-kostela-ruzova.html#reviews-more ",
								"useReviews": true,
								"useReviewsThreshold": 4.35,
								"use_rating": true,
								"use_total": true
							},
							"source": "firm",
							"stats": {
								"isPaid": false,
								"query": "",
								"subjectId": 2471353
							},
							"title": "Restaurace U kostela",
							"titleVars": {
								"locationMain1": "Růžová 30, Růžová, Czechia",
								"locationMain2": [
									"Růžová 30",
									"Růžová, Czechia"
								],
								"specification": "Restaurants",
								"titleSmartMain": "Restaurace U kostela"
							},
							"typeId": 5322,
							"typeName": "Restaurants"
						},
						"poiagg_timestamp": 1689752143940
					}
				},
				"scheduled": 1689752143,
				"firm_id": 12832594,
				"canBeRated": true,
				"review_data": {
					"total": 31,
					"caption": "Hodnocení",
					"review_weight": 13.781133303739507,
					"review_rating": 84,
					"review_rating_stars": 4.2,
					"review_rating_caption": "Very good",
					"use_rating": true,
					"use_total": true,
					"type": "firm",
					"structured_rating": [
						{
							"key": "jidloapiti",
							"name": "Food and drink",
							"label": "Quality",
							"rating": null
						},
						{
							"key": "obsluha",
							"name": "Service",
							"label": "Your satisfaction with service",
							"rating": null
						},
						{
							"key": "prostredi",
							"name": "Interior",
							"label": "Attractiveness",
							"rating": null
						},
						{
							"key": "cena",
							"name": "Price",
							"label": "Corresponding with offered services",
							"rating": null
						}
					],
					"target_stars": 4,
					"reviews": [],
					"review_poi": {
						"source": "firm",
						"id": 12832594
					}
				}
			}
		]
	};
}

interface IGetActiveRequest {
	rrid: number;
}

export function getActiveRequestOutput({
	rrid,
}: IGetActiveRequest) {
	return {
		"id": rrid,
		"action": "photo_uploaded",
		"state": "sent",
		"source": "firm",
		"backend": "firmy",
		"time": 1690272323,
		"created": 1690272323,
		"processed": true,
		"data": {
			"poi": {
				"source": "firm",
				"id": 453223,
				"poiagg": {
					"enabled": true,
					"extend": {
						"address": {
							"additional_info": "direction to the centre",
							"city": "Praha",
							"district": "Praha",
							"street": "Plzeňská",
							"zip": "15000"
						},
						"contact": {
							"email": {
								"label": "E-mail",
								"value": [
									"station.praha.plzenskajih@omv.com"
								]
							},
							"phone": {
								"label": "Phone",
								"value": [
									{
										"countrycode": "+420",
										"number": "257223961",
										"type": "phone"
									}
								]
							},
							"url": "https://www.omv.cz/cs-cz#utm_source=mapy.cz&utm_medium=ppd&utm_campaign=firmy.cz-453223"
						},
						"fuel": {
							"label": "Fuel prices on 06/23/2023",
							"value": [
								{
									"currency": "CZK",
									"date": 1687471200,
									"id": 2,
									"name": "Petrol",
									"price": "38,70 Kč",
									"priceValue": "38.70"
								},
								{
									"currency": "CZK",
									"date": 1687557600,
									"id": 1,
									"name": "Diesel",
									"price": "33,90 Kč",
									"priceValue": "33.90"
								}
							]
						},
						"opening": {
							"actual": "today nonstop",
							"actualSeason": 0,
							"actualState": "open",
							"actualStateCaption": "Open",
							"label": "Opening hours",
							"lang": "en",
							"seasons": [
								{
									"active": 3,
									"days": {
										"1": {
											"date": "2023-07-31",
											"interval": [],
											"specificationId": "nonstop",
											"specificationText": "Nonstop"
										},
										"2": {
											"date": "2023-08-01",
											"interval": [],
											"specificationId": "nonstop",
											"specificationText": "Nonstop"
										},
										"3": {
											"date": "2023-07-26",
											"interval": [],
											"specificationId": "nonstop",
											"specificationText": "Nonstop"
										},
										"4": {
											"date": "2023-07-27",
											"interval": [],
											"specificationId": "nonstop",
											"specificationText": "Nonstop"
										},
										"5": {
											"date": "2023-07-28",
											"interval": [],
											"specificationId": "nonstop",
											"specificationText": "Nonstop"
										},
										"6": {
											"date": "2023-07-29",
											"interval": [],
											"specificationId": "nonstop",
											"specificationText": "Nonstop"
										},
										"7": {
											"date": "2023-07-30",
											"interval": [],
											"specificationId": "nonstop",
											"specificationText": "Nonstop"
										}
									},
									"end": 1231,
									"label": "01 January – 31 December",
									"start": 101
								}
							],
							"timezone": 7200
						}
					},
					"fulltextPopularity": 0.2089879959821701,
					"fulltextPopularityBrand": 0.15035399794578552,
					"id": 453223,
					"inactive": false,
					"isCenter": false,
					"mark": {
						"lat": 50.0690491667,
						"lon": 14.3586372222
					},
					"media": {},
					"multiTitle": [
						"OMV",
						"Plzeňská, Prague, Czechia"
					],
					"popularity": 0.21347199380397797,
					"popularityBrand": 0.17137500643730164,
					"review": {
						"agingDailyMultiplier": 0.9981,
						"averageReviewPercentage": 80,
						"caption": "Review",
						"label": "Review",
						"penalized": false,
						"reviewAgingSpeed": "rychle stárnoucí",
						"reviewCount": 1,
						"reviewCountWeighted": 0.2921795446162247,
						"reviewLabel": "Very good",
						"review_rating": 80,
						"review_rating_caption": "Very good",
						"review_rating_stars": 4,
						"review_weight": 0.2921795446162247,
						"stars": 4,
						"total": 1,
						"type": "firm",
						"url": "https://en.firmy.cz/company/453223-omv-praha.html#reviews-more ",
						"useReviews": false,
						"useReviewsThreshold": 4.35,
						"use_rating": false,
						"use_total": true
					},
					"source": "firm",
					"stats": {
						"isPaid": false,
						"query": "",
						"subjectId": 2034882
					},
					"title": "OMV",
					"titleVars": {
						"locationMain1": "Plzeňská, Prague, Czechia",
						"locationMain2": [
							"Plzeňská",
							"Prague, Czechia"
						],
						"specification": "Petrol station",
						"titleSmartMain": "OMV"
					},
					"typeId": 5313,
					"typeName": "Petrol station"
				},
				"poiagg_timestamp": 1690272323577
			}
		},
		"scheduled": 1690272323,
		"user": {
			"id": "44362571",
			"source": "rus"
		},
		"rated": false,
		"review_data": {
			"total": 1,
			"caption": "Hodnocení",
			"review_weight": 0.2921795446162247,
			"review_rating": 80,
			"review_rating_stars": 4,
			"review_rating_caption": "Very good",
			"badge": "count",
			"use_rating": false,
			"use_total": true,
			"review_tier": 1,
			"review_tier_threshold": 2,
			"type": "firm",
			"structured_rating": [],
			"target_stars": 4,
			"reviews": [],
			"review_poi": {
				"source": "firm",
				"id": 453223
			}
		}
	};
}
